/** 列数超过 10 时用于「显示列」复选框的配置（不含选择列、操作列） */

export const DEVICE_LIST_COLUMNS = [
  { key: 'rowNo', label: '序号' },
  { key: 'siteName', label: '站点名称' },
  { key: 'deviceName', label: '设备名称/ID' },
  { key: 'terminalType', label: '终端类型' },
  { key: 'projectCategoryName', label: '项目分类' },
  { key: 'model', label: '型号', visible: false },
  { key: 'enabledStatus', label: '启用状态' },
  { key: 'protocolType', label: '协议类型' },
  { key: 'customerName', label: '使用客户', visible: false },
  { key: 'updateTime', label: '更新时间' },
  { key: 'meterTime', label: '采集时间' },
  { key: 'hardwareCode', label: '硬件编码', visible: false },
  { key: 'lngLat', label: '经度/纬度', visible: false },
  { key: 'terminalStatus', label: '终端状态', visible: false },
  { key: 'timeoutMinutes', label: '超时设定(分钟)', visible: false }
]

export const TERMINAL_MONITOR_COLUMNS = [
  { key: 'rowNo', label: '序号' },
  { key: 'siteName', label: '站点名称' },
  { key: 'deviceInfo', label: '设备信息' },
  { key: 'subDevice', label: '子设备' },
  { key: 'deviceType', label: '设备类型' },
  { key: 'stdTotal', label: '标况累积 Nm³' },
  { key: 'stdInstant', label: '标况瞬时 Nm³/h' },
  { key: 'workTotal', label: '工况累积 m³' },
  { key: 'workInstant', label: '工况瞬时 m³/h' },
  { key: 'pressure', label: '压力 Kpa' },
  { key: 'temperature', label: '温度 ℃' },
  { key: 'inletPressure', label: '进口压力 Kpa' },
  { key: 'outletPressure', label: '出口压力 Kpa' },
  { key: 'concentration', label: '进口泄露' },
  { key: 'dayUsage', label: '当日用量' },
  { key: 'monthUsage', label: '月用量' },
  { key: 'dayDefault', label: '日缺省值' },
  { key: 'monthDefault', label: '月缺省值' },
  { key: 'updateTime', label: '更新时间' },
  { key: 'status', label: '状态' }
]

export const ALARM_REALTIME_COLUMNS = [
  { key: 'rowNo', label: '序号' },
  { key: 'alarmTime', label: '告警时间' },
  { key: 'siteName', label: '站点名称' },
  { key: 'meterName', label: '表具名称' },
  { key: 'deviceType', label: '设备类型' },
  { key: 'deviceCode', label: '设备编号' },
  { key: 'alarmType', label: '报警类型' },
  { key: 'timeoutSec', label: '超时时间(秒)' },
  { key: 'alarmValue', label: '报警值' },
  { key: 'setValue', label: '设置值' },
  { key: 'currentValue', label: '当前值' },
  { key: 'operator', label: '操作人' },
  { key: 'status', label: '状态' }
]

export const ALARM_HISTORY_COLUMNS = [
  { key: 'title', label: '告警标题' },
  { key: 'deviceType', label: '设备类型' },
  { key: 'deviceCode', label: '设备编号' },
  { key: 'terminalCode', label: '终端编号' },
  { key: 'alarmType', label: '告警类型' },
  { key: 'alarmLevel', label: '级别' },
  { key: 'alarmStatus', label: '状态' },
  { key: 'alarmTime', label: '告警时间' },
  { key: 'resolveTime', label: '处理时间' },
  { key: 'content', label: '告警内容' }
]

export const REPORT_DAILY_COLUMNS = [
  { key: 'rowNo', label: '序号' },
  { key: 'reportDate', label: '时间' },
  { key: 'stationName', label: '站点名称' },
  { key: 'siteName', label: '设备名称' },
  { key: 'subDevice', label: '子设备' },
  { key: 'stdTotal', label: '标况累积(m³)' },
  { key: 'stdInstant', label: '标况瞬时(m³/h)' },
  { key: 'workTotal', label: '工况累积(m³)' },
  { key: 'workInstant', label: '工况瞬时(m³/h)' },
  { key: 'pressure', label: '压力(Kpa)' },
  { key: 'temperature', label: '温度(℃)' },
  { key: 'recordStatus', label: '状态' }
]

export const REPORT_MONTHLY_COLUMNS = [
  { key: 'rowNo', label: '序号' },
  { key: 'monthLabel', label: '月份' },
  { key: 'siteName', label: '设备名称' },
  { key: 'regionName', label: '所属区域' },
  { key: 'stdTotal', label: '标况累积(m³)' },
  { key: 'stdInstant', label: '标况瞬时(m³/h)' },
  { key: 'workTotal', label: '工况累积(m³)' },
  { key: 'workInstant', label: '工况瞬时(m³/h)' },
  { key: 'dayAvg', label: '日均用量' },
  { key: 'monthPeak', label: '月峰值' },
  { key: 'recordStatus', label: '状态' }
]

export const REPORT_YEARLY_COLUMNS = [
  { key: 'rowNo', label: '序号' },
  { key: 'yearLabel', label: '年份' },
  { key: 'siteName', label: '设备名称' },
  { key: 'regionName', label: '所属区域' },
  { key: 'stdTotal', label: '标况累积(m³)' },
  { key: 'monthAvg', label: '月均用量' },
  { key: 'yearPeak', label: '年峰值' },
  { key: 'workTotal', label: '工况累积(m³)' },
  { key: 'compareRate', label: '同比' },
  { key: 'recordStatus', label: '状态' }
]

export const REPORT_CUSTOM_COLUMNS = [
  { key: 'rowNo', label: '序号' },
  { key: 'dateRange', label: '统计区间' },
  { key: 'siteName', label: '设备名称' },
  { key: 'regionName', label: '所属区域' },
  { key: 'stdTotal', label: '标况累积(m³)' },
  { key: 'stdInstant', label: '标况瞬时(m³/h)' },
  { key: 'workTotal', label: '工况累积(m³)' },
  { key: 'workInstant', label: '工况瞬时(m³/h)' },
  { key: 'pressure', label: '压力(Kpa)' },
  { key: 'temperature', label: '温度(℃)' },
  { key: 'recordStatus', label: '状态' }
]

export const REPORT_USAGE_COLUMNS = [
  { key: 'rowNo', label: '序号' },
  { key: 'siteName', label: '站点名称' },
  { key: 'regionName', label: '所属区域' },
  { key: 'dayUsage', label: '日用量' },
  { key: 'monthUsage', label: '月用量' },
  { key: 'yearUsage', label: '年用量' },
  { key: 'dayRate', label: '日环比' },
  { key: 'monthRate', label: '月环比' },
  { key: 'peakInstant', label: '峰值瞬时' },
  { key: 'avgInstant', label: '平均瞬时' },
  { key: 'lastCommTime', label: '最后通讯' }
]
